import React from 'react';
import { BrandThemingProvider } from '@dreebit-registry/vsm-microservice-components';
import { IndustryType, useIndustryType } from '../hooks/useIndustryType';

/**
 * Selects the primary brand palette from the logged-in user's industry type.
 * SEMICONDUCTOR users get the "argos" palette (#cc0000); everyone else keeps "busch".
 *
 * Must be mounted inside ReactKeycloakProvider so the JWT is available.
 *
 * Note: the `as` cast covers the window before the shared library is republished
 * with "argos" in its BrandName union; it stays valid once the dependency is bumped.
 */
const DynamicBrandTheming = ({ children }: { children?: React.ReactNode }) => {
  const industryType = useIndustryType();
  const brand = industryType === IndustryType.SEMICONDUCTOR ? 'argos' : 'busch';

  return (
    <BrandThemingProvider brand={brand as 'busch'}>
      {children}
    </BrandThemingProvider>
  );
};

export default DynamicBrandTheming;
